module.exports = __webpack_public_path__ + "img/edge_divers_autre.7eb512f6.svg";